import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { articlesApi } from '../services/articlesApi';
import './Actualites.css';
import './ActualiteDetail.css';

function fmtDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}
function readTime(content) {
  const words = String(content || '').trim().split(/\s+/).length;
  return `${Math.max(1, Math.round(words / 220))} min`;
}
function imageBg(article) {
  if (article?.imageUrl) return `url('${article.imageUrl}')`;
  const seed = article?.imageSeed || `cb-news-${article?.slug || 'fallback'}`;
  return `url('https://picsum.photos/seed/${seed}/2200/1300')`;
}

const CAT_LABELS = {
  jeunesse: 'Jeunesse',
  spirituel: 'Spirituel',
  environnement: 'Environnement',
  sport: 'Sport · ASC',
  culture: 'Culture',
  mairie: 'Mairie',
};

const ActualiteDetail = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    articlesApi.getBySlug(slug)
      .then((data) => { if (!cancelled) { setArticle(data.article); setLoading(false); } })
      .catch((err) => { if (!cancelled) { setError(err); setLoading(false); } });
    return () => { cancelled = true; };
  }, [slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  if (loading) {
    return (
      <main className="art-page art-page-loading">
        <div className="wrap">
          <p>Chargement…</p>
        </div>
      </main>
    );
  }

  if (error || !article) {
    return (
      <main className="art-page art-page-404">
        <div className="wrap">
          <span className="eyebrow">Erreur · {error?.status || 404}</span>
          <h1>Article introuvable.</h1>
          <p>L'article que vous cherchez n'existe pas ou n'est plus disponible.</p>
          <Link to="/actualites" className="btn btn-primary">
            <span>Retour aux actualités</span>
            <span className="arrow">→</span>
          </Link>
        </div>
      </main>
    );
  }

  const catLbl = CAT_LABELS[article.category] || article.category;

  return (
    <main className="art-page">
      <header className="art-hero">
        <div className="art-hero-bg" style={{ backgroundImage: imageBg(article) }} />
        <div className="art-hero-grad" />
        <div className="wrap art-hero-inner">
          <Link to="/actualites" className="art-back">← Retour aux actualités</Link>
          <span className={`art-cat ${article.category}`}>{catLbl}</span>
          <h1>{article.title}</h1>
          {article.excerpt && <p className="art-lede">{article.excerpt}</p>}
          <div className="art-meta">
            <span>{fmtDate(article.publishedAt)}</span>
            <span className="sep">·</span>
            <span>{article.author}</span>
            <span className="sep">·</span>
            <span>Lecture · {readTime(article.content)}</span>
          </div>
        </div>
      </header>

      <article className="art-body">
        <div className="wrap">
          {article.content.split(/\n\n+/).map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      </article>

      <section className="art-cta">
        <div className="wrap">
          <Link to="/actualites" className="btn btn-outline">
            <span>Toutes les actualités</span>
            <span className="arrow">→</span>
          </Link>
        </div>
      </section>
    </main>
  );
};

export default ActualiteDetail;
